module.exports = __webpack_public_path__ + "static/media/rainfall_alert_small.cbf99692.png";